import React from 'react';
import useAsyncGuiHandler from '../../../../hooks/useAsyncHandler';
import { useBooth } from '../../../../hooks/useBooth';
import { Booth } from '../../../../interfaces/interfaces';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { updateBooth } from '../../../../services/services';
import VyTextField from '../../../common/VyTextField';

interface BoothLogoProps {
  booth: Booth;
}

const BoothSlogan = ({ booth }: BoothLogoProps) => {
  const event = useSelector((state) => state.admin.event ?? state.common.event);

  const [handleAsync] = useAsyncGuiHandler();
  const { fetchAndUpdateBooth } = useBooth();

  async function updateExhibitor({ target }: React.FocusEvent<{ value: string; name: string }>) {
    try {
      await updateBooth({ boothid: booth._id, [target.name]: target.value });
      fetchAndUpdateBooth(booth._id);
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="flex items-center w-full">
      {(event?.template?.uiTemplate !== 'vystem-light' || event?.organization?.supportedPagebuilderThemes?.includes('mbw')) && (
        <div className="w-full px-8 pt-6">
          <VyTextField
            name="slogan"
            defaultValue={booth.slogan}
            fullWidth
            onBlur={(e) => handleAsync(updateExhibitor(e))}
            className="user-input name-input"
            label="Slogan"
          />
        </div>
      )}
    </div>
  );
};

export default BoothSlogan;
